export const formatPrice = (value: number): string => `$${value.toFixed(2)}`;
export const formatDiscount = (value: number): string => `${value}% off`;
